var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login_contenter" },
    [
      _c("loginHeader"),
      _c(
        "div",
        { staticClass: "login_content", class: { isPopFrame: _vm.isPopFrame } },
        [
          _c(
            "div",
            {
              staticClass: "login_cont",
              attrs: { "data-w": _vm.windowInnerWidth },
            },
            [
              _c(
                "div",
                { staticClass: "login_form" },
                [
                  _c("closeModalBtn", { ref: "closeModalBtn" }),
                  _c("div", { staticClass: "login_type" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: ["wx", "dd"].includes(_vm.loginType),
                            expression: "['wx', 'dd'].includes(loginType)",
                          },
                        ],
                        staticClass: "login_type_item",
                        class: { active: ["wx", "dd"].includes(_vm.loginType) },
                      },
                      [_vm._v(_vm._s(_vm.$t("WeiXinDengLu", [_vm.SFName])))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !["wx", "dd"].includes(_vm.loginType),
                            expression: "!['wx', 'dd'].includes(loginType)",
                          },
                        ],
                        staticClass: "login_type_item",
                        class: { active: _vm.loginType === "tel" },
                        on: {
                          click: function ($event) {
                            return _vm.typeChange("tel")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("YanZhengMaDengLu")))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !["wx", "dd"].includes(_vm.loginType),
                            expression: "!['wx', 'dd'].includes(loginType)",
                          },
                        ],
                        staticClass: "login_type_item",
                        class: { active: _vm.loginType === "pwd" },
                        on: {
                          click: function ($event) {
                            return _vm.typeChange("pwd")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("MiMaDengLu")))]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: ["wx", "dd"].includes(_vm.loginType),
                          expression: "['wx', 'dd'].includes(loginType)",
                        },
                      ],
                      staticClass: "login_item",
                    },
                    [
                      _vm.loginType === "wx"
                        ? _c("div", { attrs: { id: "login_container" } }, [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.QrCode,
                                  expression: "QrCode",
                                },
                              ],
                              attrs: {
                                src: _vm.QrCode,
                                alt: _vm.$t("WeiXinDengLu", [_vm.$t("weiXin")]),
                                width: "224",
                                height: "224",
                              },
                            }),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.QrCode,
                                    expression: "!QrCode",
                                  },
                                ],
                                staticClass: "loadCont",
                              },
                              [_vm._m(0)]
                            ),
                          ])
                        : _vm._e(),
                      _vm.loginType === "dd"
                        ? _c("DDLogin", {
                            attrs: { isKeepMore: _vm.isKeepMore },
                            on: {
                              loginSuccess: _vm.loginIsSuccessfullyRedirected,
                            },
                          })
                        : _vm._e(),
                      _vm.loginType === "wx"
                        ? _c("div", { staticClass: "wx_text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "QingShiYongWeiXinSaoMiaoErWeiMaDengLu",
                                  [_vm.SFName]
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "sy_login_bottom" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "remember_me",
                              model: {
                                value: _vm.isKeepMore,
                                callback: function ($$v) {
                                  _vm.isKeepMore = $$v
                                },
                                expression: "isKeepMore",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("30TianNeiJiZhuWo")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                color: "var(--font-color)",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.typeChange("tel")
                                },
                              },
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("QiTaDengLuFangShi"))),
                              _c("i", { staticClass: "el-icon-right" }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loginType === "tel",
                          expression: "loginType==='tel'",
                        },
                      ],
                      staticClass: "login_item",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "login_form_cont" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "loginTelForm",
                              attrs: {
                                rules: _vm.rules,
                                model: _vm.telForm,
                                "label-width": "0px",
                                size: "medium",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "tel" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("ShouJiHaoYouXiang"),
                                      readonly: _vm.btnStatus.loginNoteBtn,
                                      "auto-complete": "false",
                                    },
                                    model: {
                                      value: _vm.telForm.tel,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.telForm, "tel", $$v)
                                      },
                                      expression: "telForm.tel",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.showCaptcha.codeLogin
                                ? _c(
                                    "el-form-item",
                                    { attrs: { prop: "verificationCode" } },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "calc(100% - 150px)",
                                        },
                                        attrs: {
                                          placeholder:
                                            _vm.$t("TuXingYanZhengMa"),
                                          readonly: _vm.btnStatus.loginNoteBtn,
                                          "auto-complete": "false",
                                          maxlength: "6",
                                        },
                                        model: {
                                          value: _vm.telForm.verificationCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.telForm,
                                              "verificationCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "telForm.verificationCode",
                                        },
                                      }),
                                      _c("img", {
                                        staticClass: "imgCode",
                                        attrs: {
                                          src: _vm.imgCodeData.loginNoteImgCode,
                                          alt: _vm.$t("YanZhengMa"),
                                          title: _vm.$t(
                                            "DianJiQieHuanYanZhengMa"
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.loginChangeCodeFn(
                                              "loginNoteImgCode"
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "telVerificationCode" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("YanZhengMa"),
                                      maxlength: "6",
                                      readonly: _vm.btnStatus.loginNoteBtn,
                                      "auto-complete": "false",
                                    },
                                    model: {
                                      value: _vm.telForm.telVerificationCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.telForm,
                                          "telVerificationCode",
                                          $$v
                                        )
                                      },
                                      expression: "telForm.telVerificationCode",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "getNoteCodeBtn",
                                      attrs: {
                                        type: "text",
                                        disabled: _vm.noteCodeBtn,
                                      },
                                      on: { click: _vm.getNoteCode },
                                    },
                                    [_vm._v(_vm._s(_vm.telCodeText))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "protocol",
                                  attrs: { prop: "checked" },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: _vm.btnStatus.loginNoteBtn,
                                      },
                                      model: {
                                        value: _vm.telForm.checked,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.telForm, "checked", $$v)
                                        },
                                        expression: "telForm.checked",
                                      },
                                    },
                                    [
                                      _c("i18n", {
                                        attrs: { path: "WoYiYueDuBingTongYi" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tos",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    staticClass: "sy_reg_atc",
                                                    attrs: {
                                                      type: "primary",
                                                      href:
                                                        _vm.$urls.dtranxUrl +
                                                        "/home/UserAgreement?locale=" +
                                                        _vm.language,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("YongHuXieYi")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "privacy",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    staticClass: "sy_reg_atc",
                                                    attrs: {
                                                      type: "primary",
                                                      href:
                                                        _vm.$urls.dtranxUrl +
                                                        "/home/PrivacyPolicy?locale=" +
                                                        _vm.language,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "YinSiShengMing"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { staticClass: "protocol" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: _vm.btnStatus.loginNoteBtn,
                                      },
                                      model: {
                                        value: _vm.isKeepMore,
                                        callback: function ($$v) {
                                          _vm.isKeepMore = $$v
                                        },
                                        expression: "isKeepMore",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("30TianNeiJiZhuWo")))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { size: "large" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "loginBtn",
                                      attrs: {
                                        type: "primary",
                                        loading: _vm.btnStatus.loginNoteBtn,
                                      },
                                      on: { click: _vm.telSubmit },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("DengLu")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "sy_auto_explain" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "WeiZhuCeDeShouJiHaoYouXiangYanZhengChengGongHouJiangZiDongZhuCe"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loginType === "pwd",
                          expression: "loginType==='pwd'",
                        },
                      ],
                      staticClass: "login_item",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "login_form_cont pwd_mb",
                          class: { verificationCode: _vm.showCaptcha.pwdLogin },
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "loginPwdForm",
                              attrs: {
                                rules: _vm.pwdRules,
                                model: _vm.pwdForm,
                                "label-width": "0px",
                                size: "medium",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "telEmail" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      readonly: _vm.btnStatus.loginPwdBtn,
                                      placeholder: _vm.$t("ShouJiHaoYouXiang"),
                                    },
                                    model: {
                                      value: _vm.pwdForm.telEmail,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pwdForm, "telEmail", $$v)
                                      },
                                      expression: "pwdForm.telEmail",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "item-error el-form-item__error",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.checkTelEmailErrorMsg) +
                                          " "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.toRegister,
                                              expression: "toRegister",
                                            },
                                          ],
                                          staticStyle: { cursor: "pointer" },
                                          on: { click: _vm.toRegisterFn },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("QuZhuCe")) + ">>"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "telPwd" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        readonly: _vm.btnStatus.loginPwdBtn,
                                        placeholder: _vm.$t("MiMa"),
                                        type: !_vm.showPwdIcon
                                          ? "password"
                                          : "text",
                                        clearable: _vm.windowInnerWidth > 499,
                                      },
                                      model: {
                                        value: _vm.pwdForm.telPwd,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.pwdForm, "telPwd", $$v)
                                        },
                                        expression: "pwdForm.telPwd",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-input__icon iconfont",
                                        class: {
                                          "yyq-icon-hide": !_vm.showPwdIcon,
                                          "yyq-icon-view": _vm.showPwdIcon,
                                        },
                                        attrs: { slot: "suffix" },
                                        on: { click: _vm.showPwdFn },
                                        slot: "suffix",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.showCaptcha.pwdLogin
                                ? _c(
                                    "el-form-item",
                                    { attrs: { prop: "verificationCode" } },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "calc(100% - 150px)",
                                        },
                                        attrs: {
                                          readonly: _vm.btnStatus.loginPwdBtn,
                                          placeholder:
                                            _vm.$t("TuXingYanZhengMa"),
                                          "auto-complete": "false",
                                        },
                                        model: {
                                          value: _vm.pwdForm.verificationCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.pwdForm,
                                              "verificationCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pwdForm.verificationCode",
                                        },
                                      }),
                                      _c("img", {
                                        staticClass: "imgCode",
                                        attrs: {
                                          src: _vm.imgCodeData.loginPwdImgCode,
                                          alt: _vm.$t("YanZhengMa"),
                                          title: _vm.$t(
                                            "DianJiQieHuanYanZhengMa"
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.loginChangeCodeFn(
                                              "loginPwdImgCode"
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "protocol",
                                  attrs: { prop: "checked" },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: _vm.btnStatus.loginPwdBtn,
                                      },
                                      model: {
                                        value: _vm.pwdForm.checked,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.pwdForm, "checked", $$v)
                                        },
                                        expression: "pwdForm.checked",
                                      },
                                    },
                                    [
                                      _c("i18n", {
                                        attrs: { path: "WoYiYueDuBingTongYi" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tos",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    staticClass: "sy_reg_atc",
                                                    attrs: {
                                                      type: "primary",
                                                      href:
                                                        _vm.$urls.dtranxUrl +
                                                        "/home/UserAgreement?locale=" +
                                                        _vm.language,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("YongHuXieYi")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "privacy",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-link",
                                                  {
                                                    staticClass: "sy_reg_atc",
                                                    attrs: {
                                                      type: "primary",
                                                      href:
                                                        _vm.$urls.dtranxUrl +
                                                        "/home/PrivacyPolicy?locale=" +
                                                        _vm.language,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "YinSiShengMing"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { staticClass: "protocol" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: _vm.btnStatus.loginNoteBtn,
                                      },
                                      model: {
                                        value: _vm.isKeepMore,
                                        callback: function ($$v) {
                                          _vm.isKeepMore = $$v
                                        },
                                        expression: "isKeepMore",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("30TianNeiJiZhuWo")))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "12px" },
                                  attrs: { size: "large" },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "loginBtn",
                                      attrs: {
                                        type: "primary",
                                        loading: _vm.btnStatus.loginPwdBtn,
                                      },
                                      on: { click: _vm.pwdSubmit },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("DengLu")))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "var(--font-color)",
                                    "font-size": "16px",
                                    cursor: "pointer",
                                    "text-align": "center",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toPath("/forgetPwd")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("WangJiMiMa")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  ["tel", "pwd"].includes(_vm.loginType)
                    ? _c("div", { staticClass: "sy_login_bottom" }, [
                        _vm.windowInnerWidth > 499
                          ? _c("span", { staticClass: "others-login" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("QiTaDengLuFangShi")) +
                                  "： "
                              ),
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/weixin-icon.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.goOthersLogin("wx")
                                  },
                                },
                              }),
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/dingding-icon.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.goOthersLogin("dd")
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            attrs: { type: "primary", href: "javascript:;" },
                            on: {
                              click: function ($event) {
                                return _vm.toPath("/register")
                              },
                            },
                          },
                          [
                            _vm._v(_vm._s(_vm.$t("ZhuCeZhangHao")) + " "),
                            _c("i", { staticClass: "el-icon-right" }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wx_loading" }, [
      _c("div", { staticClass: "load" }, [
        _c("div", { staticClass: "load_white" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }